import { render, staticRenderFns } from "./list-formation.vue?vue&type=template&id=291f7f51&"
import script from "./list-formation.vue?vue&type=script&lang=js&"
export * from "./list-formation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports